import { Title } from '@angular/platform-browser';
import { Component, OnInit, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExecutionHistoryService } from '../execution-history.service';

@Component({
  selector: 'app-testcase',
  templateUrl: './testcase.component.html',
  styleUrls: ['./testcase.component.less']
})

export class TestcaseComponent implements OnInit {

  myProjects: any[];
  users: any[];
  testCaseResultList: any[];
  filterParams: any;
  executionStatusList: any[];
  page: number = 1;
  pageSize = 15;
  dataNotFound = false;
  moreData = true;
  dataLoaded = false;

  constructor(private titleService: Title, private router: Router, private executionHistoryService: ExecutionHistoryService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.getMyProjects();
    this.getUsers();
    this.route.queryParams.subscribe((params) => {
      let searchParams = JSON.parse(JSON.stringify(params));
      if(searchParams.default === undefined) {
        if(localStorage.getItem("defaultUserConfig") !== null && JSON.parse(localStorage.getItem("defaultUserConfig")).default_project) {
          searchParams.projectIds = [JSON.parse(localStorage.getItem("defaultUserConfig")).default_project];
        }
      } else {
        delete searchParams.default;
      }
      this.getTestcaseResultList(searchParams);
      this.titleService.setTitle('Exec-History | TC');
    });
    this.executionStatusList = JSON.parse(localStorage.getItem('about')).executionStatuses;
  }

  getMyProjects() {
    this.executionHistoryService.getMyProjectList().pipe().subscribe(data => {
      if (data.code === 200) {
        this.myProjects = data.response;
      }
    });
  }

  getUsers() {
    this.executionHistoryService.getUsersList().pipe().subscribe(data => {
      if (data.code === 200) {
        this.users = data.response;
      }
    });
  }

  getTestcaseResultList(searchParams) {
    this.testCaseResultList = [];
    this.dataNotFound = false;
    this.executionHistoryService.getExecutionHistory(searchParams).pipe().subscribe(data => {
      if (data.code === 200) {
        this.dataLoaded = true;
        this.testCaseResultList = data.response.testCases;
        this.page = searchParams.page;
        if (this.testCaseResultList.length < this.pageSize) this.moreData = false;
        else this.moreData = true;
      } else {
        this.dataNotFound = true;
        this.moreData = false;
        this.testCaseResultList = [];
        this.page = 1;
      }
    });
  }

  loadmore(page) {
    this.moreData = true;
    this.page = parseInt(page) + 1
    let searchParams = this.filterParams;
    const collection = {
      page: parseInt(page) + 1 || 1,
      size: this.pageSize || 15,
      executedBy: JSON.parse(localStorage.getItem('user')).id,
      executionType: 'TEST_CASE'
    };
    searchParams = { ...collection, ...searchParams };
    this.executionHistoryService.getExecutionHistory(searchParams).pipe().subscribe(data => {
      if (data.code === 200) {
        data.response.testCases.map(testcase => {
          this.testCaseResultList.push(testcase);
        });
      } else {
        this.moreData = false;
      }
    });
  }

  pagination() {
    let searchParams = this.filterParams;
    const collection = {
      page: this.page || 1,
      size: this.pageSize || 15,
      executedBy: JSON.parse(localStorage.getItem('user')).id,
      executionType: 'TEST_CASE',
      default: false
    };
    searchParams = { ...collection, ...searchParams };
    this.router.navigate(['.'], { relativeTo: this.route, queryParams: searchParams });
  }

  paginateWithFilterParams(value: any): void {
    if (value) {
      this.page = 1;
      this.filterParams = value;
    }
    this.pagination();
  }

}
